module.exports = "mutation ($id: ID!) {\n  FormSubmitDelete(id: $id) {\n    id\n  }\n}\n"